import {FaBan} from "react-icons/fa";

export const BLOCKED_AGENCY_MESSAGE = "Agency blocked — cannot assign to worker";

export default function BlockedAgencyIcon() {
    return (
        <FaBan
            aria-label={BLOCKED_AGENCY_MESSAGE}
            role="img"
            title={BLOCKED_AGENCY_MESSAGE}
            style={{color: "#dc3545", marginLeft: "5px", verticalAlign: "-0.1em"}}
        />
    );
}
